import { BrowserModule } from '@angular/platform-browser';
import { AuthRoutingModule } from './auth-routing.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { MdButtonModule } from '@angular/material';
import { MdInputModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { LoginComponent } from './login/login.component';
import { AcceptTermsComponent } from './accept-terms/accept-terms.component';


@NgModule({
    declarations: [
        LoginComponent,
        AcceptTermsComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        AuthRoutingModule,
        MdInputModule,
        MdButtonModule,
        MaterialModule,
        ReactiveFormsModule,
        HttpModule
    ],
    entryComponents: [ AcceptTermsComponent ],
})

export class AuthModule {

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/auth/auth.module.ts